import { Outlet } from 'react-router-dom';
import { SiPortalHeader } from './SiPortalHeader';
import { useGuardarUltimaAbaSi } from '../hooks/useSiPortalUltimaAba';

export function SiPortalLayout() {
  useGuardarUltimaAbaSi();
  return (
    <div className="space-y-8 pb-12">
      <SiPortalHeader />
      <Outlet />
    </div>
  );
}
